import { httpClient } from "@/lib/http-client"
import { type Site, type Point, type IFeatureReport } from "@/lib/models"

export interface MapData {
  id: string
  name: string
  description: string | null
  zoom: number
  latitude: number,
  longitude: number,
  createdAt: string
  updatedAt: string
  polygonCount: number
  pinCount: number
  thumbnail?: string
  isPublic: boolean
  ownerId: string
}

export interface SiteSummary {
  name: string
  description: string | null
}

export interface CreateMapRequest {
  name: string
  description?: string
  isPublic?: boolean
}

export interface UpdateMapRequest {
  name: string
  description?: string | null
  point: Point
  zoom: number
}

export interface AttachmentDetails {
  id: string
  filename: string
  url: string
  size: number
}

export class SiteService {
  private static readonly BASE_PATH = "/api/sites"

  static async getUserMaps(): Promise<MapData[]> {
    return httpClient.get<MapData[]>(this.BASE_PATH)
  }

  static async getSiteById(siteId: string): Promise<Site> {
    return httpClient.get<Site>(`${this.BASE_PATH}/${siteId}`)
  }

  static async createMap(data: CreateMapRequest): Promise<MapData> {
    return httpClient.post<MapData>(this.BASE_PATH, data)
  }

  static async updateSiteSummary(mapId: string, data: SiteSummary): Promise<void> {
    return httpClient.patch<void>(`${this.BASE_PATH}/${mapId}`, data)
  }

  static async deleteMap(mapId: string): Promise<void> {
    return httpClient.delete(`${this.BASE_PATH}/${mapId}`)
  }

  static async duplicateMap(mapId: string, name: string): Promise<MapData> {
    return httpClient.post<MapData>(`${this.BASE_PATH}/${mapId}/duplicate`, { name })
  }

  static async createFeatureReport(siteId: string, report: IFeatureReport): Promise<void> {
    return httpClient.download(`${this.BASE_PATH}/${siteId}/report/feature`, report)
  }
}
